import { useContext } from 'preact/hooks'
import SeamlyActivityEventContext from 'ui/components/core/seamly-activity-event-context'

const useSeamlyActivityEventHandler = () => {
  const onActivityHandler = useContext(SeamlyActivityEventContext)

  if (!onActivityHandler) {
    throw new Error(
      'useSeamlyActivityEventHandler has to be used within <SeamlyActivityEventContext.Provider>',
    )
  }

  return onActivityHandler
}

export default useSeamlyActivityEventHandler
